// extracted by mini-css-extract-plugin
export var authorByLineTooltipTrigger = "bj_df";
export var authorBylineContainer = "bj_dc";
export var authorPrefix = "bj_dd";